"use client"

import { createContext, useContext } from "react"

const StorefrontThemeContext = createContext<string | null>(null)

export const StorefrontThemeProvider = ({
  theme,
  children,
}: {
  theme: string | null
  children: React.ReactNode
}) => {
  return (
    <StorefrontThemeContext.Provider value={theme}>
      {children}
    </StorefrontThemeContext.Provider>
  )
}

export const useStorefrontTheme = () => useContext(StorefrontThemeContext)
